var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import GenericModal from './ibok-core/module/GenericModal';
import useBrowserAuthMe from '../hooks/useBrowserAuthMe';
import { contentTypeUrlEnc, urlEncodeData } from '../utils/api/apiHelper';
var ContactUsModal = function (_a) {
    var onDismiss = _a.onDismiss;
    var user = useBrowserAuthMe().user;
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var _c = React.useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = React.useState(false), isSent = _d[0], setIsSent = _d[1];
    var submit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var fields, response, result, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setError(null);
                    setIsSubmitting(true);
                    fields = new FormData(event.currentTarget);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch('/main/contactSmas', {
                            method: 'POST',
                            headers: { 'Content-Type': contentTypeUrlEnc },
                            body: urlEncodeData([
                                ['name', fields.get('name') || ''],
                                ['email', fields.get('email') || ''],
                                ['message', fields.get('message') || ''],
                            ]),
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _a.sent();
                    if (!response.ok || result.error) {
                        setError(result.msg || 'Kunne ikke sende meldingen. Prøv igjen.');
                        return [2 /*return*/];
                    }
                    setIsSent(true);
                    return [3 /*break*/, 6];
                case 4:
                    _error_1 = _a.sent();
                    setError('Fikk ikke kontakt med serveren. Prøv igjen.');
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return React.createElement(GenericModal, { className: "contact-us-modal", title: "Kontakt oss", onDismiss: onDismiss }, isSent
        ? React.createElement(React.Fragment, null,
            React.createElement("p", { role: "status" }, "Takk, meldingen er sendt."),
            React.createElement("button", { type: "button", onClick: onDismiss }, "Lukk"))
        : React.createElement("form", { className: "vertical", onSubmit: submit },
            error && React.createElement("p", { className: "form-error", role: "alert" }, error),
            React.createElement("label", { htmlFor: "contact-name" }, "Ditt navn:"),
            React.createElement("input", { id: "contact-name", name: "name", type: "text", autoComplete: "name", defaultValue: user === null || user === void 0 ? void 0 : user.name }),
            React.createElement("label", { htmlFor: "contact-email" }, "Din e-postadresse:"),
            React.createElement("input", { id: "contact-email", name: "email", type: "email", autoComplete: "email", defaultValue: user === null || user === void 0 ? void 0 : user.email, required: true }),
            React.createElement("label", { htmlFor: "contact-message" }, "Melding til oss:"),
            React.createElement("textarea", { id: "contact-message", name: "message", rows: 7, minLength: 8, required: true }),
            React.createElement("button", { type: "submit", disabled: isSubmitting }, isSubmitting ? 'Sender…' : 'Send'),
            React.createElement("button", { type: "button", className: "plain", onClick: onDismiss }, "Avbryt")));
};
var StandaloneFooter = function () {
    var _a = React.useState(false), showContactForm = _a[0], setShowContactForm = _a[1];
    React.useEffect(function () {
        var openContactForm = function (event) {
            if (!(event.target instanceof Element) || !event.target.closest('.contact-us')) {
                return;
            }
            event.preventDefault();
            setShowContactForm(true);
        };
        document.addEventListener('click', openContactForm);
        return function () { return document.removeEventListener('click', openContactForm); };
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement("footer", null,
            React.createElement("div", { className: "socialshare" },
                React.createElement("div", { className: "socialshare__links" },
                    React.createElement("a", { className: "fab fa-instagram socialbutton", href: "https://www.instagram.com/ibok.no/", target: "_blank", rel: "noreferrer noopener", "aria-label": "Instagram" }),
                    React.createElement("a", { className: "fab fa-facebook-f socialbutton", href: "https://www.facebook.com/ibok.no", target: "_blank", rel: "noreferrer noopener", "aria-label": "Facebook" }),
                    React.createElement("a", { className: "fab fa-tiktok socialbutton", href: "https://www.tiktok.com/@iboktok", target: "_blank", rel: "noreferrer noopener", "aria-label": "TikTok" }))),
            React.createElement("div", { className: "columns" },
                React.createElement("nav", { className: "links" },
                    React.createElement("a", { href: "/hjelp" }, "Hjelp"),
                    React.createElement("a", { href: "/om" }, "Om iBok"),
                    React.createElement("a", { href: "", className: "contact-us" }, "Kontakt oss"),
                    React.createElement("a", { href: "/betingelser" }, "Brukervilk\u00E5r"),
                    React.createElement("a", { href: "/personvern" }, "Personvern"))),
            React.createElement("p", { className: "copyright" },
                React.createElement("strong", { className: "date" }, new Date().getFullYear()),
                " \u00A9",
                ' ',
                React.createElement("a", { href: "https://studentmediene.no/" }, "Studentmediene i Trondheim AS"))),
        showContactForm && React.createElement(ContactUsModal, { onDismiss: function () { return setShowContactForm(false); } }));
};
export default StandaloneFooter;
